exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".topComp {\n  height: 100%; }\n\n.topComp .grid {\n  width: 100%;\n  padding-top: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/deleted-vapps/deleted-vapps.scss
// module id = U4x1
// module chunks = 0